import { z } from "zod";

export const UpdateProfileSchema = z.object({
    name: z.string().min(3).max(255),
    email: z.string().email(),
    phone: z.string().min(3).max(255),
});

export type UpdateProfileType = z.infer<typeof UpdateProfileSchema>;